/**
 * Sélecteur de langue pour les générations IA
 */

import { Select, SelectItem } from '@carbon/react'
import type { SupportedLanguage } from '@sphere/ai/domain'

interface LanguageSelectorProps {
  value: SupportedLanguage
  onChange: (language: SupportedLanguage) => void
  disabled?: boolean
  className?: string
}

const LANGUAGES = [
  { code: 'fr' as const, name: 'Français', flag: '🇫🇷' },
  { code: 'en' as const, name: 'English', flag: '🇬🇧' },
]

export function LanguageSelector({
  value,
  onChange,
  disabled = false,
  className = '',
}: LanguageSelectorProps) {
  return (
    <div className={className}>
      <Select
        id="language-select"
        labelText=""
        hideLabel
        value={value}
        onChange={e => onChange(e.target.value as SupportedLanguage)}
        disabled={disabled}
      >
        {LANGUAGES.map(lang => (
          <SelectItem
            key={lang.code}
            value={lang.code}
            text={`${lang.flag} ${lang.name}`}
          />
        ))}
      </Select>
    </div>
  )
}
